import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
  Typography,
  Box,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Paper,
  Divider,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
  LocalShipping as ShippingIcon,
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  ShoppingCart as CartIcon,
  ErrorOutline as ErrorOutlineIcon,
} from "@mui/icons-material";
import invoiceService from "../../../../services/invoicesService";

const steps = ["Fatura Bilgileri", "Taslak Oluşturma", "İşlem Sonucu"];

const InvoiceCreatePopUpModel = ({ open, handleClose, order, userId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [createdInvoiceId, setCreatedInvoiceId] = useState(null);
  const [resultMessage, setResultMessage] = useState("");
  const handleNext = () => {
    setStep(1);
  };
  const handleCreateInvoice = async () => {
    setLoading(true);
    setError(null);
    try {
      // InvoiceCustomerWD Name: Order'dan InvoiceCustomerFirstName/LastName null ise customerFirstName/LastName kullan
      const invoiceFirstName = (order.invoiceCustomerFirstName != null && order.invoiceCustomerFirstName !== '')
        ? order.invoiceCustomerFirstName
        : order.customerFirstName;
      const invoiceLastName = (order.invoiceCustomerLastName != null && order.invoiceCustomerLastName !== '')
        ? order.invoiceCustomerLastName
        : order.customerLastName;
      const invoiceCustomerWDName = `${invoiceFirstName || ''} ${invoiceLastName || ''}`.trim();

      const invoiceData = {
        userId: userId,
        orderId: order.id,
        recordType: 0,
        status: 0,
        profileType: 0,
        type: order.status == 4 || order.status == 5 ? 2 : 1,
        currencyCode: order.currencyCode || "TRY",
        paymentMeansCode: 48,
        note: "",
        totalAmount: parseFloat(order.totalPrice) || 0,
        invoiceRecordType: 2, //manuel mi değil mi kontrolü
        ia: true,
        ettn: "",
        userOfCustomerId: 0,
        customerLastName: order.customerLastName,
        customerFirstName: order.customerFirstName,
        invoiced: true,
        invoiceCustomerWD: {
          name: invoiceCustomerWDName,
        },
        userOfCustomer: {
          userId: userId,
          type: 0,
          identifier: order.taxNumber || order.tcIdentityNumber,
          taxOffice: order.taxOffice || "",
          name: `${order.customerFirstName || ""} ${
            order.customerLastName || ""
          }`.trim(),
          mail: order.customerEmail || "",
          country: order.country || "TR",
          province: order.province || "",
          district: order.district || "",
          detail: order.address || "",
          ia: true,
        },
        invoiceLines: (order.orderLines || []).map((item) => ({
          ia: true,
          inventoryCard: item.productName || "",
          quantity: parseFloat(item.quantity) || 0,
          unitCode: "C62",
          price: parseFloat(item.price) || 0,
          vatRate: parseFloat(item.vatRate) || 0,
          lineExtensionAmount: parseFloat(item.amount) || 0,
          discountRate: 0,
          discountAmount: parseFloat(item.discountPrice) || 0,
          vatIncluded: true,
          description: item.productName || "",
          productId: item.productId || 0,
        })),
        invoiceAddresses: (order.orderAddresses || []).map((item) => ({
          type: item.adresType,
          addressDetail: item.addressDetail,
          orderId: order.id,
          ia: true,
          District: item.districtName,
          neighborhoodName: item.neighborhoodName || item.districtName,
          country: item.country,
          City: item.provinceName,
          provinceName: item.provinceName,
          name: order.customerFirstName,
          personSurName: order.customerLastName,
          identificationNumber: order.taxNumber || order.tcIdentityNumber,
          email: order.customerEmail,
        })),

        issueDate: new Date().toISOString(),
        paymentDueDate: new Date().toISOString(),
      };

      const result = await invoiceService.createInvoice(invoiceData);

      if (result.status === true) {
        setCreatedInvoiceId(result.data.id);
        setSuccess(true);
        setResultMessage(result.message);
      } else {
        setError(result.message || "Fatura oluşturulurken bir hata oluştu");
        setSuccess(false);
      }
    } catch (error) {
      console.error("Error in handleCreateInvoice:", error);
      setError(
        error.response?.data?.message || "Fatura oluşturulurken bir hata oluştu"
      );
      setSuccess(false);
    } finally {
      setLoading(false);
      setStep(2);
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case 0:
        return (
          <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 1.5, sm: 2 },
                mb: { xs: 2, sm: 3 },
                background: "linear-gradient(135deg, #1E293B 0%, #334155 100%)",
                color: "white",
                borderRadius: { xs: 2, sm: 3 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1, sm: 2 },
                  mb: { xs: 1.5, sm: 2 },
                }}
              >
                <CartIcon sx={{ fontSize: { xs: 32, sm: 40 }, opacity: 0.9 }} />
                <Box>
                  <Typography
                    variant={isMobile ? "h6" : "h5"}
                    sx={{ fontWeight: 600, mb: 0.5 }}
                  >
                    Sipariş #{order.orderNumber}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    {new Date(order.orderDate).toLocaleDateString("tr-TR")}
                  </Typography>
                </Box>
              </Box>
              <Chip
                label={order.cargoProviderName || "Kargo"}
                size="small"
                sx={{
                  bgcolor: "rgba(255,255,255,0.1)",
                  color: "white",
                  "& .MuiChip-label": { px: { xs: 1, sm: 2 } },
                }}
              />
            </Paper>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "1fr 1fr",
                },
                gap: { xs: 2, sm: 3 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 2, sm: 3 },
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 2.5 },
                    borderRadius: { xs: 2, sm: 3 },
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 1, sm: 1.5 },
                      mb: { xs: 1.5, sm: 2 },
                    }}
                  >
                    <PersonIcon
                      sx={{
                        color: "primary.main",
                        fontSize: { xs: 20, sm: 24 },
                      }}
                    />
                    <Typography
                      variant={isMobile ? "subtitle2" : "subtitle1"}
                      sx={{ fontWeight: 600 }}
                    >
                      Müşteri Bilgileri
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: { xs: 1, sm: 1.5 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1.5,
                        bgcolor: "#F8FAFC",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Ad Soyad
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {order.customerFirstName} {order.customerLastName}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1.5,
                        bgcolor: "#F8FAFC",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        E-posta
                      </Typography>
                      <Typography variant="body2">
                        {order.customerEmail || "-"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1.5,
                        bgcolor: "#F8FAFC",
                        borderRadius: 2,
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Vergi No
                      </Typography>
                      <Typography variant="body2">
                        {order.customerTaxNumber || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 2.5 },
                    borderRadius: { xs: 2, sm: 3 },
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 1, sm: 1.5 },
                      mb: { xs: 1.5, sm: 2 },
                    }}
                  >
                    <ShippingIcon
                      sx={{
                        color: "success.main",
                        fontSize: { xs: 20, sm: 24 },
                      }}
                    />
                    <Typography
                      variant={isMobile ? "subtitle2" : "subtitle1"}
                      sx={{ fontWeight: 600 }}
                    >
                      Teslimat Bilgileri
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      p: { xs: 1.5, sm: 2 },
                      bgcolor: "#F8FAFC",
                      borderRadius: { xs: 1.5, sm: 2 },
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#475569",
                        lineHeight: 1.6,
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                      }}
                    >
                      {order.orderAddresses[0]
                        ? order.orderAddresses[0].addressDetail
                        : "Adres Bulunamadı"}
                    </Typography>
                  </Box>
                </Paper>
              </Box>

              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, sm: 2.5 },
                  borderRadius: { xs: 2, sm: 3 },
                  border: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 1, sm: 1.5 },
                    mb: { xs: 1.5, sm: 2 },
                  }}
                >
                  <ReceiptIcon
                    sx={{ color: "info.main", fontSize: { xs: 20, sm: 24 } }}
                  />
                  <Typography
                    variant={isMobile ? "subtitle2" : "subtitle1"}
                    sx={{ fontWeight: 600 }}
                  >
                    Sipariş Özeti
                  </Typography>
                </Box>

                <Box sx={{ mb: { xs: 2, sm: 3 } }}>
                  {order.orderItems?.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: { xs: 1, sm: 1.5 },
                        p: { xs: 1.5, sm: 2 },
                        bgcolor: "#F8FAFC",
                        borderRadius: { xs: 1.5, sm: 2 },
                        border: "1px solid",
                        borderColor: "divider",
                        "&:last-child": { mb: 0 },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                          flexDirection: { xs: "column", sm: "row" },
                          gap: { xs: 0.5, sm: 0 },
                        }}
                      >
                        <Typography
                          variant={isMobile ? "body2" : "subtitle2"}
                          sx={{ fontWeight: 500 }}
                        >
                          {item.productName}
                        </Typography>
                        <Typography
                          variant={isMobile ? "body2" : "subtitle2"}
                          sx={{ fontWeight: 600, color: "primary.main" }}
                        >
                          {item.totalPrice} {order.currencyCode}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          color: "text.secondary",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: { xs: 0.5, sm: 0 },
                        }}
                      >
                        <Typography variant="caption">
                          {item.quantity} adet x {item.unitPrice}{" "}
                          {order.currencyCode}
                        </Typography>
                        <Typography variant="caption">
                          KDV: %{item.vatRate || 18}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>

                <Divider sx={{ mb: { xs: 1.5, sm: 2 } }} />
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Ara Toplam
                    </Typography>
                    <Typography variant="body2">
                      {order.totalPrice} {order.currencyCode}
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      KDV
                    </Typography>
                    <Typography variant="body2">
                      {order.vatAmount || "0.00"} {order.currencyCode}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 2,
                      bgcolor: "#F8FAFC",
                      borderRadius: 2,
                      mt: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      Genel Toplam
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, color: "primary.main" }}
                    >
                      {order.totalPrice} {order.currencyCode}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Box>
        );

      case 1:
        return (
          <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, textAlign: "center" }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 2, sm: 3 },
                maxWidth: 500,
                mx: "auto",
                borderRadius: { xs: 2, sm: 3 },
                bgcolor: "#F8FAFC",
                border: "1px solid #E2E8F0",
              }}
            >
              <Typography
                variant={isMobile ? "subtitle1" : "h6"}
                gutterBottom
                sx={{ color: "#1E293B", fontWeight: 600 }}
              >
                Taslak Oluşturuluyor
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                sx={{ mb: { xs: 2, sm: 3 }, color: "#475569" }}
              >
                Fatura taslağı oluşturulacak. Onaylıyor musunuz?
              </Typography>

              <Box
                sx={{
                  p: { xs: 1.5, sm: 2 },
                  bgcolor: "white",
                  borderRadius: { xs: 1.5, sm: 2 },
                  border: "1px solid #E2E8F0",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Sipariş Numarası
                </Typography>
                <Typography
                  variant={isMobile ? "subtitle1" : "h6"}
                  sx={{ color: "#1E293B", fontWeight: 600 }}
                >
                  #{order.orderNumber}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 1, sm: 2 },
                  justifyContent: "center",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => setStep(0)}
                  fullWidth={isMobile}
                  sx={{
                    borderRadius: { xs: 1.5, sm: 2 },
                    px: { xs: 2, sm: 3 },
                    borderColor: "#CBD5E1",
                    color: "#475569",
                    "&:hover": {
                      borderColor: "#94A3B8",
                      bgcolor: "rgba(148, 163, 184, 0.04)",
                    },
                  }}
                >
                  Geri Dön
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCreateInvoice}
                  disabled={loading}
                  fullWidth={isMobile}
                  sx={{
                    borderRadius: { xs: 1.5, sm: 2 },
                    px: { xs: 2, sm: 3 },
                    bgcolor: "#2563EB",
                    "&:hover": {
                      bgcolor: "#1D4ED8",
                    },
                  }}
                >
                  Fatura Oluştur
                </Button>
              </Box>
            </Paper>
          </Box>
        );

      case 2:
        return (
          <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, textAlign: "center" }}>
            {success ? (
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, sm: 3 },
                  maxWidth: 500,
                  mx: "auto",
                  borderRadius: { xs: 2, sm: 3 },
                  bgcolor: "#F0FDF4",
                  border: "1px solid #86EFAC",
                }}
              >
                <CheckCircleIcon
                  sx={{
                    fontSize: { xs: 50, sm: 70 },
                    color: "#22C55E",
                    mb: { xs: 1.5, sm: 2 },
                    filter: "drop-shadow(0 4px 6px rgba(34, 197, 94, 0.2))",
                  }}
                />
                <Typography
                  variant={isMobile ? "h6" : "h5"}
                  gutterBottom
                  sx={{ color: "#15803D", fontWeight: 600 }}
                >
                  İşlem Başarılı
                </Typography>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  sx={{ mb: { xs: 2, sm: 3 }, color: "#166534" }}
                >
                  {resultMessage || "Fatura başarıyla oluşturuldu."}
                </Typography>

                <Button
                  variant="contained"
                  color="success"
                  onClick={handleClose}
                  fullWidth={isMobile}
                  sx={{
                    mt: { xs: 1.5, sm: 2 },
                    bgcolor: "#22C55E",
                    "&:hover": {
                      bgcolor: "#16A34A",
                    },
                  }}
                >
                  Tamam
                </Button>
              </Paper>
            ) : (
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, sm: 3 },
                  maxWidth: 500,
                  mx: "auto",
                  borderRadius: { xs: 2, sm: 3 },
                  bgcolor: "#FEF2F2",
                  border: "1px solid #FECACA",
                }}
              >
                <ErrorOutlineIcon
                  sx={{
                    fontSize: { xs: 50, sm: 70 },
                    color: "#EF4444",
                    mb: { xs: 1.5, sm: 2 },
                    filter: "drop-shadow(0 4px 6px rgba(239, 68, 68, 0.2))",
                  }}
                />
                <Typography
                  variant={isMobile ? "h6" : "h5"}
                  gutterBottom
                  sx={{ color: "#991B1B", fontWeight: 600 }}
                >
                  İşlem Başarısız
                </Typography>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  sx={{ mb: { xs: 2, sm: 3 }, color: "#7F1D1D" }}
                >
                  Fatura oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: 1, sm: 2 },
                    justifyContent: "center",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                    startIcon={<CloseIcon />}
                    fullWidth={isMobile}
                    sx={{
                      borderRadius: { xs: 1.5, sm: 2 },
                      px: { xs: 2, sm: 3 },
                      borderColor: "#FECACA",
                      color: "#991B1B",
                      "&:hover": {
                        borderColor: "#EF4444",
                        bgcolor: "rgba(239, 68, 68, 0.04)",
                      },
                    }}
                  >
                    Kapat
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => setStep(0)}
                    fullWidth={isMobile}
                    sx={{
                      borderRadius: { xs: 1.5, sm: 2 },
                      px: { xs: 2, sm: 3 },
                      bgcolor: "#EF4444",
                      "&:hover": {
                        bgcolor: "#DC2626",
                      },
                    }}
                  >
                    Tekrar Dene
                  </Button>
                </Box>
              </Paper>
            )}
          </Box>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: 2, sm: 3 },
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          m: { xs: 1, sm: 2 },
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: 1.5, sm: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography variant={isMobile ? "subtitle1" : "h6"}>
          Fatura Oluştur
        </Typography>
        <IconButton onClick={handleClose} size={isMobile ? "small" : "medium"}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Stepper
          activeStep={step}
          sx={{
            p: { xs: 2, sm: 3 },
            "& .MuiStepLabel-label": {
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {error && (
          <Alert
            severity="error"
            sx={{
              mx: { xs: 1, sm: 2 },
              mb: { xs: 1, sm: 2 },
              "& .MuiAlert-message": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
            }}
            onClose={() => setError(null)}
          >
            {error}
          </Alert>
        )}

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              p: { xs: 3, sm: 4 },
            }}
          >
            <CircularProgress size={isMobile ? 30 : 40} />
          </Box>
        ) : (
          renderStepContent()
        )}
      </DialogContent>

      <DialogActions
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderTop: "1px solid",
          borderColor: "divider",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Button
          onClick={handleClose}
          disabled={loading}
          fullWidth={isMobile}
          sx={{ mr: { xs: 0, sm: 1 } }}
        >
          {step === 2 ? "Kapat" : "İptal"}
        </Button>
        {step === 0 && (
          <Button
            onClick={handleNext}
            variant="contained"
            color="primary"
            fullWidth={isMobile}
          >
            Devam Et
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceCreatePopUpModel;
